import {
  Fragment, useMemo } from "react";
  import { useTranslation } from "react-i18next";
  import {
  ShoppingOutlined,
  ClusterOutlined,
  CarOutlined,
  FileDoneOutlined,
  ArrowRightOutlined,
  RightOutlined,
} from "@ant-design/icons";
import "../style.css";

const iconByKey: Record<string, JSX.Element> = {
  order: <ShoppingOutlined />,
  distribute: <ClusterOutlined />,
  deliver: <CarOutlined />,
  reconcile: <FileDoneOutlined />,
};

interface WorkflowFlowProps {
  className?: string;
  variant?: "default" | "compact";
}

const WorkflowFlow = ({ className = "", variant = "default" }: WorkflowFlowProps) => {
  const { t } = useTranslation("dms");
  const isCompact = variant === "compact";

  const steps = useMemo(() => {
    const raw = t("workflow.steps", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ key: string; label: string }>;
  }, [t]);

  return (
    <div
      className={[
        "dev-dms-workflow-grid",
        isCompact ? "dev-dms-workflow--compact" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="dev-dms-workflow-track">
        {steps.map((step, idx) => (
          <Fragment key={step.key}>
            {isCompact ? (
              <div className="dev-dms-step-item">
                <div className={`dev-dms-step-card dev-dms-step-card--${step.key}`}>
                  <div className="dev-dms-step-icon">{iconByKey[step.key] ?? <RightOutlined />}</div>
                </div>
                <div className="dev-dms-step-title">{step.label}</div>
              </div>
            ) : (
              <div className={`dev-dms-step-card dev-dms-step-card--${step.key}`}>
                <div className="dev-dms-step-icon">{iconByKey[step.key] ?? <RightOutlined />}</div>
                <div className="dev-dms-step-title">{step.label}</div>
              </div>
            )}
            {idx < steps.length - 1 && (
              <div className="dev-dms-step-connector" aria-hidden>
                <ArrowRightOutlined />
              </div>
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default WorkflowFlow;
